import React, { useState, useEffect, useRef } from 'react';
import {
  Typography,
  Box,
  Paper,
  Grid,
  Button,
  Tabs,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  IconButton,
  Chip,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  OutlinedInput,
  Tooltip,
} from '@mui/material';
import {
  Add as AddIcon,
  ArrowForward as ArrowIcon,
  PictureAsPdf as PdfIcon,
  TableChart as ExcelIcon,
  Receipt as ReceiptIcon,
  Edit as EditIcon,
  Delete as DeleteIcon,
  Visibility as ViewIcon,
  AddPhotoAlternate as AddPhotoIcon,
  DeleteForever as DeletePhotoIcon,
  CameraAlt as CameraIcon,
} from '@mui/icons-material';
import { exportToPDF, exportToExcel } from '../services/exportService';
import api from '../services/api';
import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { useCaja } from '../contexts/CajaContext';
import { useAuth } from '../contexts/AuthContext';
const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

function Ventas() {
  const { user, isAdmin } = useAuth();
  const [tabValue, setTabValue] = useState(0);
  const [cotizaciones, setCotizaciones] = useState([]);
  const [pedidos, setPedidos] = useState([]);
  const [facturas, setFacturas] = useState([]);
  const [entregas, setEntregas] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [productos, setProductos] = useState([]);
  
  const [openDialog, setOpenDialog] = useState(false);
  const [openConvertir, setOpenConvertir] = useState(false);
  const [tipoConversion, setTipoConversion] = useState('');
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  // Estado para preview de imagen del producto seleccionado
  const [imagenPreview, setImagenPreview] = useState(null);

  // Estado para búsqueda de productos en el dropdown
  const [busquedaProducto, setBusquedaProducto] = useState('');

  // Estados para filtros
  const [busqueda, setBusqueda] = useState('');
  const [filtroEstado, setFiltroEstado] = useState('');

  const [formCotizacion, setFormCotizacion] = useState({
    codigo: '',
    cliente_id: '',
    fecha_cotizacion: new Date().toISOString().split('T')[0],
    observaciones: '',
    items: [{ producto_id: '', cantidad: 1, precio_unitario: '' }]
  });

  const [formConversion, setFormConversion] = useState({
    codigo: '',
    fecha: '',
    observaciones: '',
    metodo_pago: 'efectivo',
    direccion_entrega: '',
    responsable: ''
  });

  // ============================================
  // ESTADOS PARA EDITAR / ELIMINAR / PDF COTIZACIÓN
  // ============================================
  const [openEditarCotizacion, setOpenEditarCotizacion] = useState(false);
  const [cotizacionEditando, setCotizacionEditando] = useState(null);
  const [openEliminarCotizacion, setOpenEliminarCotizacion] = useState(false);
  const [cotizacionEliminar, setCotizacionEliminar] = useState(null);

  // ============================================
  // ESTADOS PARA GESTIÓN DE IMÁGENES DE PRODUCTO
  // ============================================
  const [openImagenDialog, setOpenImagenDialog] = useState(false);
  const [productoImagen, setProductoImagen] = useState(null);
  const [archivoImagen, setArchivoImagen] = useState(null);
  const fileInputRef = useRef(null);

  // ============================================
  // ESTADOS PARA IMÁGENES DE MÉTODOS DE PAGO
  // ============================================
  const [metodosPagoImagenes, setMetodosPagoImagenes] = useState({});
  const [openMetodoPagoImagenDialog, setOpenMetodoPagoImagenDialog] = useState(false);
  const [metodoPagoSeleccionado, setMetodoPagoSeleccionado] = useState(null);
  const [archivoMetodoPago, setArchivoMetodoPago] = useState(null);
  const [refreshMetodosPago, setRefreshMetodosPago] = useState(0);
  const fileInputMetodoPagoRef = useRef(null);

  useEffect(() => {
    cargarDatos();
    cargarMetodosPagoImagenes();
  }, []);

  useEffect(() => {
  if (openConvertir && tipoConversion === 'factura') {
    console.log('🔄 Recargando imágenes de métodos de pago...');
    cargarMetodosPagoImagenes();
  }
}, [openConvertir, tipoConversion, refreshMetodosPago]);

  const cargarDatos = async () => {
    try {
      const [resCot, resPed, resFac, resEnt, resCli, resProd] = await Promise.all([
        api.get('/ventas/cotizaciones'),
        api.get('/ventas/pedidos'),
        api.get('/ventas/facturas'),
        api.get('/ventas/entregas'),
        api.get('/clientes'),
        api.get('/productos'),
      ]);
      setCotizaciones(resCot.data.data);
      setPedidos(resPed.data.data);
      setFacturas(resFac.data.data);
      setEntregas(resEnt.data.data);
      // Ordenar clientes alfabéticamente por nombre
      const clientesOrdenados = resCli.data.data.sort((a, b) => 
        a.nombre.localeCompare(b.nombre, 'es', { sensitivity: 'base' })
      );
      setClientes(clientesOrdenados);
      setProductos(resProd.data.data);
    } catch (error) {
      console.error('Error cargando datos:', error);
    }
  };

  // ============================================
  // CARGAR IMÁGENES DE MÉTODOS DE PAGO
  // ============================================
  const cargarMetodosPagoImagenes = async () => {
  try {
    const res = await api.get('/metodos-pago');
    console.log('✅ Métodos de pago cargados:', res.data.data);
    const imagenesMap = {};
    res.data.data.forEach(mp => {
      imagenesMap[mp.metodo] = mp.imagen;
    });
    setMetodosPagoImagenes(imagenesMap);
  } catch (error) {
    console.error('❌ Error cargando imágenes de métodos de pago:', error);
  }
};

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setBusqueda('');
    setFiltroEstado('');
  };

  // CAJA CONTEXT
  const { cajaActual, cargarCajaActual, recalcularVentasHoy } = useCaja();
  
  const [openCajaDialog, setOpenCajaDialog] = useState(false);
  const [montoApertura, setMontoApertura] = useState('');
  const [montoCierre, setMontoCierre] = useState('');
  const [observacionesCaja, setObservacionesCaja] = useState('');
  const [openHistorial, setOpenHistorial] = useState(false);
  const [historialCajas, setHistorialCajas] = useState([]);

  useEffect(() => {
    cargarCajaActual();
    cargarHistorialCajas();
  }, []);

  useEffect(() => {
    verificarCaja();
  }, []);

  const verificarCaja = async () => {
    try {
      const usuario_id = 1;
      const res = await api.get(`/cajas/actual/${usuario_id}`);
    } catch (error) {
      console.error('Error verificando caja:', error);
    }
  };

  const handleAbrirCaja = async () => {
    try {
      const usuario_id = 1;
      await api.post('/cajas/apertura', {
        usuario_id,
        monto_apertura: parseFloat(montoApertura),
        observaciones: observacionesCaja
      });
      setOpenCajaDialog(false);
      setMontoApertura('');
      setObservacionesCaja('');
      await cargarCajaActual();
      setSnackbar({ open: true, message: 'Caja abierta correctamente', severity: 'success' });
    } catch (error) {
      setSnackbar({ open: true, message: 'Error: ' + error.message, severity: 'error' });
    }
  };

  const handleCerrarCaja = async () => {
    try {
      await api.post(`/cajas/cierre/${cajaActual.id}`, {
        monto_cierre: parseFloat(montoCierre),
        observaciones: observacionesCaja
      });
      setOpenCajaDialog(false);
      setMontoCierre('');
      setObservacionesCaja('');
      await cargarCajaActual();
      setSnackbar({ open: true, message: 'Caja cerrada correctamente', severity: 'success' });
    } catch (error) {
      setSnackbar({ open: true, message: 'Error: ' + error.message, severity: 'error' });
    }
  };

  const cargarHistorialCajas = async () => {
    try {
      const res = await api.get('/cajas/historial');
      setHistorialCajas(res.data.data || []);
    } catch (error) {
      console.error('Error cargando historial:', error);
      setHistorialCajas([]);
    }
  };

  const validarCampos = (camposRequeridos) => {
    for (const [campo, valor] of Object.entries(camposRequeridos)) {
      if (!valor || valor === '' || (Array.isArray(valor) && valor.length === 0)) {
        setSnackbar({ 
          open: true, 
          message: `El campo "${campo}" es obligatorio`, 
          severity: 'error' 
        });
        return false;
      }
    }
    return true;
  };

  const handleOpenCotizacion = () => {
    setImagenPreview(null);
    setFormCotizacion({
      codigo: `COT-${Date.now().toString().slice(-6)}`,
      cliente_id: '',
      fecha_cotizacion: new Date().toISOString().split('T')[0],
      observaciones: '',
      items: [{ producto_id: '', cantidad: 1, precio_unitario: '' }]
    });
    setOpenDialog(true);
  };

  const handleAddItem = () => {
    setFormCotizacion({
      ...formCotizacion,
      items: [...formCotizacion.items, { producto_id: '', cantidad: 1, precio_unitario: '' }]
    });
  };

  const handleItemChange = (index, field, value) => {
    const newItems = [...formCotizacion.items];
    newItems[index][field] = value;
    if (field === 'producto_id') {
      const prod = productos.find(p => p.id === parseInt(value));
      if (prod) {
        newItems[index].precio_unitario = prod.precio_venta;
        if (prod.imagen) {
          setImagenPreview({
            url: `http://localhost:5000${prod.imagen}`,
            nombre: prod.nombre,
            index: index,
            producto_id: prod.id
          });
        } else {
          setImagenPreview({
            url: null,
            nombre: prod.nombre,
            index: index,
            producto_id: prod.id
          });
        }
      }
    }
    setFormCotizacion({ ...formCotizacion, items: newItems });
  };

  const handleRemoveItem = (index) => {
    const newItems = formCotizacion.items.filter((_, i) => i !== index);
    setFormCotizacion({ ...formCotizacion, items: newItems });
    if (imagenPreview?.index === index) {
      setImagenPreview(null);
    }
  };

  const calcularTotal = () => {
    let totalConIGV = 0;
    formCotizacion.items.forEach(item => {
      // El precio_unitario ya incluye IGV (como en la factura real)
      totalConIGV += (parseFloat(item.cantidad) || 0) * (parseFloat(item.precio_unitario) || 0);
    });
    // Calcular base gravada restando IGV (precio ÷ 1.18)
    const subtotal = totalConIGV / 1.18;
    const igv = totalConIGV - subtotal; // o subtotal * 0.18
    return { 
      subtotal: subtotal,      // Op. Gravada (base sin IGV)
      igv: igv,                 // IGV (18%)
      total: totalConIGV         // Importe Total (con IGV incluido)
    };
  };

  const handleSubmitCotizacion = async () => {
    if (!validarCampos({
      'Cliente': formCotizacion.cliente_id,
      'Fecha': formCotizacion.fecha_cotizacion,
      'Productos': formCotizacion.items
    })) return;

    for (let i = 0; i < formCotizacion.items.length; i++) {
      const item = formCotizacion.items[i];
      if (!item.producto_id) {
        setSnackbar({ open: true, message: `Selecciona un producto en la fila ${i + 1}`, severity: 'error' });
        return;
      }
      if (!item.cantidad || item.cantidad < 1) {
        setSnackbar({ open: true, message: `La cantidad en la fila ${i + 1} debe ser mayor a 0`, severity: 'error' });
        return;
      }
      if (!item.precio_unitario || item.precio_unitario <= 0) {
        setSnackbar({ open: true, message: `El precio unitario en la fila ${i + 1} debe ser mayor a 0`, severity: 'error' });
        return;
      }
    }

    try {
      const usuario_id = 1;
      const totalCalculado = calcularTotal();
      await api.post('/ventas/cotizaciones', {
        ...formCotizacion,
        usuario_id,
        subtotal: totalCalculado.subtotal,
        igv: totalCalculado.igv,
        total: totalCalculado.total,
        items: formCotizacion.items.map(item => ({
          ...item,
          producto_id: parseInt(item.producto_id),
          cantidad: parseInt(item.cantidad),
          precio_unitario: parseFloat(item.precio_unitario)
        }))
      });
      setSnackbar({ open: true, message: 'Cotización creada correctamente', severity: 'success' });
      setOpenDialog(false);
      cargarDatos();
    } catch (error) {
      setSnackbar({ open: true, message: 'Error: ' + error.message, severity: 'error' });
    }
  };

  const handleConvertirAPedido = (cotizacion) => {
    setItemSeleccionado(cotizacion);
    setTipoConversion('pedido');
    setFormConversion({
      codigo: `PED-${Date.now().toString().slice(-6)}`,
      fecha: new Date().toISOString().split('T')[0],
      observaciones: '',
      metodo_pago: 'efectivo',
      direccion_entrega: '',
      responsable: ''
    });
    setOpenConvertir(true);
  };

  const handleConvertirAFactura = (pedido) => {
    setItemSeleccionado(pedido);
    setTipoConversion('factura');
    setFormConversion({
      codigo: `FAC-${Date.now().toString().slice(-6)}`,
      fecha: new Date().toISOString().split('T')[0],
      observaciones: '',
      metodo_pago: 'efectivo',
      direccion_entrega: '',
      responsable: '',
      tipo_documento: 'factura'
    });
    setOpenConvertir(true);
  };

  const handleProgramarEntrega = (factura) => {
    setItemSeleccionado(factura);
    setTipoConversion('entrega');
    setFormConversion({
      codigo: `ENT-${Date.now().toString().slice(-6)}`,
      fecha: new Date().toISOString().split('T')[0],
      observaciones: '',
      metodo_pago: 'efectivo',
      direccion_entrega: '',
      responsable: ''
    });
    setOpenConvertir(true);
  };

  // ============================================
  // GENERAR FACTURA PDF
  // ============================================
  const generarFacturaPDF = async (entrega) => {
    try {
      const res = await api.get(`/ventas/entregas/${entrega.id}`);
      const datos = res.data.data || entrega;
      
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      
      doc.setFontSize(20);
      doc.setTextColor(25, 118, 210);
      doc.text('EJARAD-TIC', 14, 20);
      
      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text('Sistema de Gestión Comercial', 14, 26);
      doc.text('Piura, Perú', 14, 30);
      doc.text('RUC: 12345678901', 14, 34);
      
      doc.setFontSize(16);
      doc.setTextColor(0);
      const tituloDocumento = datos.tipo_documento === 'boleta' ? 'BOLETA DE VENTA' : 'FACTURA DE VENTA';
      doc.text(tituloDocumento, pageWidth - 14, 20, { align: 'right' });
      
      doc.setFontSize(10);
      doc.text(`N° ${datos.factura_codigo || 'FAC-000000'}`, pageWidth - 14, 26, { align: 'right' });
      doc.text(`Fecha: ${new Date().toLocaleDateString('es-PE')}`, pageWidth - 14, 30, { align: 'right' });
      
      doc.setDrawColor(25, 118, 210);
      doc.setLineWidth(0.5);
      doc.line(14, 38, pageWidth - 14, 38);
      
      doc.setFontSize(12);
      doc.setTextColor(25, 118, 210);
      doc.text('DATOS DEL CLIENTE', 14, 46);
      
      doc.setFontSize(10);
      doc.setTextColor(0);
      doc.text(`Cliente: ${datos.cliente_nombre || 'Cliente no especificado'}`, 14, 53);
      const docLabel = datos.tipo_documento === 'boleta' ? 'DNI/CE' : 'RUC/DNI';
      doc.text(`${docLabel}: ${datos.cliente_documento || datos.cliente_ruc || '-'}`, 14, 58);
      doc.text(`Dirección: ${datos.cliente_direccion || '-'}`, 14, 63);
      doc.text(`Dirección de Entrega: ${datos.direccion_entrega || '-'}`, 14, 68);
      
      doc.setFontSize(12);
      doc.setTextColor(25, 118, 210);
      doc.text('INFORMACIÓN DEL PEDIDO', 14, 78);
      
      doc.setFontSize(10);
      doc.setTextColor(0);
      doc.text(`Código de Entrega: ${datos.codigo}`, 14, 85);
      doc.text(`Código de Pedido: ${datos.pedido_codigo || '-'}`, 14, 90);
      doc.text(`Fecha de Entrega: ${new Date(datos.fecha_entrega).toLocaleDateString('es-PE')}`, 14, 95);
      
      const items = datos.items || [
        { producto: 'Producto de ejemplo', cantidad: 1, precio_unitario: 100.00 }
      ];
      
      const tableData = items.map(item => [
        item.producto || item.nombre || 'Producto',
        item.cantidad.toString(),
        `S/ ${parseFloat(item.precio_unitario).toFixed(2)}`,
        `S/ ${(item.cantidad * parseFloat(item.precio_unitario)).toFixed(2)}`
      ]);
      
      autoTable(doc, {
        startY: 102,
        head: [['Producto', 'Cantidad', 'P. Unitario', 'Subtotal']],
        body: tableData,
        theme: 'grid',
        headStyles: {
          fillColor: [25, 118, 210],
          textColor: 255,
          fontStyle: 'bold'
        },
        styles: {
          fontSize: 10,
          cellPadding: 3
        },
        columnStyles: {
          0: { cellWidth: 'auto' },
          1: { cellWidth: 25, halign: 'center' },
          2: { cellWidth: 35, halign: 'right' },
          3: { cellWidth: 35, halign: 'right' }
        }
      });
      
      const finalY = doc.lastAutoTable.finalY + 10;
      const totalConIGV = items.reduce((sum, item) => sum + (item.cantidad * parseFloat(item.precio_unitario)), 0);
      const opGravada = totalConIGV / 1.18;  // Base sin IGV
      const igv = totalConIGV - opGravada;   // IGV (18%)

      doc.setFontSize(10);
      doc.text('Op. Gravada:', pageWidth - 80, finalY);
      doc.text(`S/ ${opGravada.toFixed(2)}`, pageWidth - 14, finalY, { align: 'right' });

      doc.text('IGV (18%):', pageWidth - 80, finalY + 6);
      doc.text(`S/ ${igv.toFixed(2)}`, pageWidth - 14, finalY + 6, { align: 'right' });

      doc.setFontSize(12);
      doc.setTextColor(25, 118, 210);
      doc.text('Importe Total:', pageWidth - 80, finalY + 14);
      doc.text(`S/ ${totalConIGV.toFixed(2)}`, pageWidth - 14, finalY + 14, { align: 'right' });
      
      doc.setFontSize(9);
      doc.setTextColor(100);
      doc.text('Gracias por su preferencia.', pageWidth / 2, finalY + 30, { align: 'center' });
      doc.text('EJARAD-TIC - Sistema de Gestión Comercial v1.0.0', pageWidth / 2, finalY + 35, { align: 'center' });
      
      const nombreDoc = datos.tipo_documento === 'boleta' ? 'Boleta' : 'Factura';
doc.save(`${nombreDoc}_${datos.codigo}_${new Date().toISOString().split('T')[0]}.pdf`);
      
      await api.post(`/ventas/entregas/${entrega.id}/entregar`);
      await recalcularVentasHoy();

      setSnackbar({ 
        open: true, 
        message: `Factura generada y entrega ${datos.codigo} marcada como entregada`, 
        severity: 'success' 
      });
      
      cargarDatos();
    } catch (error) {
      console.error('Error generando factura:', error);
      setSnackbar({ 
        open: true, 
        message: 'Error al generar factura: ' + (error.response?.data?.message || error.message), 
        severity: 'error' 
      });
    }
  };

  // ============================================
  // EDITAR COTIZACIÓN
  // ============================================
  const formatearFechaInput = (fecha) => {
    if (!fecha) return '';
    if (fecha.includes('T')) {
      return fecha.split('T')[0];
    }
    const d = new Date(fecha);
    if (isNaN(d.getTime())) return '';
    return d.toISOString().split('T')[0];
  };

  const handleEditarCotizacion = async (cotizacion) => {
    try {
      const res = await api.get(`/ventas/cotizaciones/${cotizacion.id}`);
      const datos = res.data.data;
      
      setFormCotizacion({
        codigo: datos.codigo,
        cliente_id: datos.cliente_id,
        fecha_cotizacion: formatearFechaInput(datos.fecha_cotizacion),
        fecha_vencimiento: formatearFechaInput(datos.fecha_vencimiento) || '',
        observaciones: datos.observaciones || '',
        items: datos.items.map(item => ({
          producto_id: item.producto_id,
          cantidad: item.cantidad,
          precio_unitario: item.precio_unitario
        }))
      });
      
      setCotizacionEditando(datos);
      setOpenEditarCotizacion(true);
    } catch (error) {
      setSnackbar({ open: true, message: 'Error cargando cotización', severity: 'error' });
    }
  };

  const handleUpdateCotizacion = async () => {
    if (!validarCampos({
      'Cliente': formCotizacion.cliente_id,
      'Fecha': formCotizacion.fecha_cotizacion,
      'Productos': formCotizacion.items
    })) return;

    for (let i = 0; i < formCotizacion.items.length; i++) {
      const item = formCotizacion.items[i];
      if (!item.producto_id) {
        setSnackbar({ open: true, message: `Selecciona un producto en la fila ${i + 1}`, severity: 'error' });
        return;
      }
      if (!item.cantidad || item.cantidad < 1) {
        setSnackbar({ open: true, message: `La cantidad en la fila ${i + 1} debe ser mayor a 0`, severity: 'error' });
        return;
      }
      if (!item.precio_unitario || item.precio_unitario <= 0) {
        setSnackbar({ open: true, message: `El precio unitario en la fila ${i + 1} debe ser mayor a 0`, severity: 'error' });
        return;
      }
    }

    try {
      const totalCalculado = calcularTotal();
      await api.put(`/ventas/cotizaciones/${cotizacionEditando.id}`, {
        ...formCotizacion,
        subtotal: totalCalculado.subtotal,
        igv: totalCalculado.igv,
        total: totalCalculado.total,
        items: formCotizacion.items.map(item => ({
          producto_id: parseInt(item.producto_id),
          cantidad: parseInt(item.cantidad),
          precio_unitario: parseFloat(item.precio_unitario)
        }))
      });
      
      setSnackbar({ open: true, message: 'Cotización actualizada', severity: 'success' });
      setOpenEditarCotizacion(false);
      cargarDatos();
    } catch (error) {
      setSnackbar({ open: true, message: 'Error: ' + error.message, severity: 'error' });
    }
  };

  // ============================================
  // ELIMINAR COTIZACIÓN
  // ============================================
  const handleOpenEliminar = (cotizacion) => {
    setCotizacionEliminar(cotizacion);
    setOpenEliminarCotizacion(true);
  };

  const handleEliminarCotizacion = async () => {
    try {
      await api.delete(`/ventas/cotizaciones/${cotizacionEliminar.id}`);
      setSnackbar({ open: true, message: 'Cotización anulada', severity: 'success' });
      setOpenEliminarCotizacion(false);
      cargarDatos();
    } catch (error) {
      setSnackbar({ open: true, message: 'Error: ' + error.message, severity: 'error' });
    }
  };

  // ============================================
  // GENERAR PDF DE COTIZACIÓN
  // ============================================
  const generarPDFCotizacion = async (cotizacion) => {
    try {
      const res = await api.get(`/ventas/cotizaciones/${cotizacion.id}`);
      const datos = res.data.data;
      
      const doc = new jsPDF();
      const pageWidth = doc.internal.pageSize.getWidth();
      
      doc.setFontSize(20);
      doc.setTextColor(25, 118, 210);
      doc.text('EJARAD-TIC', 14, 20);
      
      doc.setFontSize(10);
      doc.setTextColor(100);
      doc.text('Sistema de Gestión Comercial', 14, 26);
      doc.text('Piura, Perú', 14, 30);
      doc.text('RUC: 12345678901', 14, 34);
      
      doc.setFontSize(16);
      doc.setTextColor(0);
      doc.text('COTIZACIÓN', pageWidth - 14, 20, { align: 'right' });
      
      doc.setFontSize(10);
      doc.text(`N° ${datos.codigo}`, pageWidth - 14, 26, { align: 'right' });
      doc.text(`Fecha: ${new Date(datos.fecha_cotizacion).toLocaleDateString('es-PE')}`, pageWidth - 14, 30, { align: 'right' });
      doc.text(`Válido hasta: ${datos.fecha_vencimiento ? new Date(datos.fecha_vencimiento).toLocaleDateString('es-PE') : 'No especificado'}`, pageWidth - 14, 34, { align: 'right' });
      
      doc.setDrawColor(25, 118, 210);
      doc.line(14, 38, pageWidth - 14, 38);
      
      doc.setFontSize(12);
      doc.setTextColor(25, 118, 210);
      doc.text('DATOS DEL CLIENTE', 14, 46);
      
      doc.setFontSize(10);
      doc.setTextColor(0);
      doc.text(`Cliente: ${datos.cliente_nombre}`, 14, 53);
      doc.text(`${datos.tipo_documento}: ${datos.numero_documento}`, 14, 58);
      doc.text(`Dirección: ${datos.direccion || '-'}`, 14, 63);
      doc.text(`Teléfono: ${datos.telefono || '-'}`, 14, 68);
      doc.text(`Email: ${datos.email || '-'}`, 14, 73);
      
      const tableData = datos.items.map(item => [
        item.producto_codigo,
        item.producto_nombre,
        item.cantidad.toString(),
        `S/ ${parseFloat(item.precio_unitario).toFixed(2)}`,
        `S/ ${(item.cantidad * parseFloat(item.precio_unitario)).toFixed(2)}`
      ]);
      
      autoTable(doc, {
        startY: 82,
        head: [['Código', 'Producto', 'Cant.', 'P. Unit.', 'Subtotal']],
        body: tableData,
        theme: 'grid',
        headStyles: { fillColor: [25, 118, 210], textColor: 255, fontStyle: 'bold' },
        styles: { fontSize: 10, cellPadding: 3 },
        columnStyles: {
          0: { cellWidth: 30 },
          1: { cellWidth: 'auto' },
          2: { cellWidth: 20, halign: 'center' },
          3: { cellWidth: 35, halign: 'right' },
          4: { cellWidth: 35, halign: 'right' }
        }
      });
      
      const finalY = doc.lastAutoTable.finalY + 10;
      const subtotal = parseFloat(datos.subtotal);
      const igv = parseFloat(datos.igv);
      const total = parseFloat(datos.total);
      
      doc.setFontSize(10);
      doc.text('Subtotal:', pageWidth - 80, finalY);
      doc.text(`S/ ${subtotal.toFixed(2)}`, pageWidth - 14, finalY, { align: 'right' });
      
      doc.text('IGV (18%):', pageWidth - 80, finalY + 6);
      doc.text(`S/ ${igv.toFixed(2)}`, pageWidth - 14, finalY + 6, { align: 'right' });
      
      doc.setFontSize(12);
      doc.setTextColor(25, 118, 210);
      doc.text('TOTAL:', pageWidth - 80, finalY + 14);
      doc.text(`S/ ${total.toFixed(2)}`, pageWidth - 14, finalY + 14, { align: 'right' });
      
      if (datos.observaciones) {
        doc.setFontSize(10);
        doc.setTextColor(100);
        doc.text('Observaciones:', 14, finalY + 30);
        doc.text(datos.observaciones, 14, finalY + 36);
      }
      
      doc.setFontSize(9);
      doc.setTextColor(100);
      doc.text('Esta cotización tiene validez de 15 días calendario.', pageWidth / 2, finalY + 50, { align: 'center' });
      doc.text('EJARAD-TIC - Sistema de Gestión Comercial v1.0.0', pageWidth / 2, finalY + 55, { align: 'center' });
      
      doc.save(`Cotizacion_${datos.codigo}.pdf`);
    } catch (error) {
      console.error('Error generando PDF:', error);
      setSnackbar({ open: true, message: 'Error al generar PDF', severity: 'error' });
    }
  };

  const handleSubmitConversion = async () => {
    try {
      let endpoint = '';
      let message = '';
      
      if (tipoConversion === 'pedido') {
        endpoint = `/ventas/cotizaciones/${itemSeleccionado.id}/convertir`;
        message = 'Cotizacion convertida a pedido';
      } else if (tipoConversion === 'factura') {
        endpoint = `/ventas/pedidos/${itemSeleccionado.id}/facturar`;
        message = 'Factura emitida correctamente';
      } else if (tipoConversion === 'entrega') {
        endpoint = `/ventas/facturas/${itemSeleccionado.id}/entregar`;
        message = 'Entrega programada correctamente';
      }
      
      await api.post(endpoint, formConversion);
      
      if (tipoConversion === 'factura') {
        await recalcularVentasHoy();
      }
      
      setSnackbar({ open: true, message, severity: 'success' });
      setOpenConvertir(false);
      cargarDatos();
    } catch (error) {
      setSnackbar({ open: true, message: 'Error: ' + error.message, severity: 'error' });
    }
  };

  // ============================================
  // FUNCIONES PARA GESTIÓN DE IMÁGENES DE PRODUCTO
  // ============================================
  const handleOpenImagenDialog = (producto) => {
    setProductoImagen(producto);
    setArchivoImagen(null);
    setOpenImagenDialog(true);
  };

  const handleCloseImagenDialog = () => {
    setOpenImagenDialog(false);
    setProductoImagen(null);
    setArchivoImagen(null);
  };

  const handleSeleccionarImagen = (event) => {
    const file = event.target.files[0];
    if (file) {
      const tiposPermitidos = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg'];
      if (!tiposPermitidos.includes(file.type)) {
        setSnackbar({ 
          open: true, 
          message: 'Solo se permiten imágenes (JPG, PNG, WEBP)', 
          severity: 'error' 
        });
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        setSnackbar({ 
          open: true, 
          message: 'La imagen no debe superar los 5MB', 
          severity: 'error' 
        });
        return;
      }
      setArchivoImagen(file);
    }
  };

  const handleSubirImagen = async () => {
    if (!archivoImagen || !productoImagen) return;

    try {
      const formData = new FormData();
      formData.append('imagen', archivoImagen);
      formData.append('nombre', productoImagen.nombre);
      formData.append('descripcion', productoImagen.descripcion || '');
      formData.append('categoria_id', productoImagen.categoria_id || '');
      formData.append('marca', productoImagen.marca || '');
      formData.append('modelo', productoImagen.modelo || '');
      formData.append('precio_compra', productoImagen.precio_compra || 0);
      formData.append('precio_venta', productoImagen.precio_venta || 0);
      formData.append('stock_minimo', productoImagen.stock_minimo || 5);
      formData.append('ubicacion_almacen', productoImagen.ubicacion_almacen || '');
      formData.append('imagen_actual', productoImagen.imagen || '');

      await api.put(`/productos/${productoImagen.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setSnackbar({ 
        open: true, 
        message: 'Imagen actualizada correctamente', 
        severity: 'success' 
      });
      
      handleCloseImagenDialog();
      cargarDatos();
      
      if (imagenPreview?.producto_id === productoImagen.id) {
        const timestamp = Date.now();
        setImagenPreview(prev => ({
          ...prev,
          url: `http://localhost:5000/imagenes/productos/producto-${productoImagen.id}-${timestamp}.jpg`
        }));
      }
    } catch (error) {
      console.error('Error subiendo imagen:', error);
      setSnackbar({ 
        open: true, 
        message: 'Error al subir imagen: ' + (error.response?.data?.message || error.message), 
        severity: 'error' 
      });
    }
  };

  const handleEliminarImagen = async () => {
    if (!productoImagen) return;

    try {
      const formData = new FormData();
      formData.append('nombre', productoImagen.nombre);
      formData.append('descripcion', productoImagen.descripcion || '');
      formData.append('categoria_id', productoImagen.categoria_id || '');
      formData.append('marca', productoImagen.marca || '');
      formData.append('modelo', productoImagen.modelo || '');
      formData.append('precio_compra', productoImagen.precio_compra || 0);
      formData.append('precio_venta', productoImagen.precio_venta || 0);
      formData.append('stock_minimo', productoImagen.stock_minimo || 5);
      formData.append('ubicacion_almacen', productoImagen.ubicacion_almacen || '');
      formData.append('imagen_actual', '');

      await api.put(`/productos/${productoImagen.id}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      setSnackbar({ 
        open: true, 
        message: 'Imagen eliminada correctamente', 
        severity: 'success' 
      });
      
      handleCloseImagenDialog();
      cargarDatos();
      
      if (imagenPreview?.producto_id === productoImagen.id) {
        setImagenPreview(prev => ({ ...prev, url: null }));
      }
    } catch (error) {
      console.error('Error eliminando imagen:', error);
      setSnackbar({ 
        open: true, 
        message: 'Error al eliminar imagen: ' + (error.response?.data?.message || error.message), 
        severity: 'error' 
      });
    }
  };

  // ============================================
  // FUNCIONES PARA IMÁGENES DE MÉTODOS DE PAGO
  // ============================================
  
  // Abrir diálogo para gestionar imagen de método de pago
  const handleOpenMetodoPagoImagenDialog = (metodo) => {
    setMetodoPagoSeleccionado({
      metodo: metodo,
      imagen: metodosPagoImagenes[metodo] || null
    });
    setArchivoMetodoPago(null);
    setOpenMetodoPagoImagenDialog(true);
  };

  const handleCloseMetodoPagoImagenDialog = () => {
    setOpenMetodoPagoImagenDialog(false);
    setMetodoPagoSeleccionado(null);
    setArchivoMetodoPago(null);
  };

  const handleSeleccionarImagenMetodoPago = (event) => {
    const file = event.target.files[0];
    if (file) {
      const tiposPermitidos = ['image/jpeg', 'image/png', 'image/webp', 'image/jpg', 'image/gif'];
      if (!tiposPermitidos.includes(file.type)) {
        setSnackbar({ 
          open: true, 
          message: 'Solo se permiten imágenes (JPG, PNG, WEBP, GIF)', 
          severity: 'error' 
        });
        return;
      }
      if (file.size > 5 * 1024 * 1024) {
        setSnackbar({ 
          open: true, 
          message: 'La imagen no debe superar los 5MB', 
          severity: 'error' 
        });
        return;
      }
      setArchivoMetodoPago(file);
    }
  };

  const handleSubirImagenMetodoPago = async () => {
    if (!archivoMetodoPago || !metodoPagoSeleccionado) return;

    try {
      const formData = new FormData();
      formData.append('imagen', archivoMetodoPago);
      formData.append('metodo', metodoPagoSeleccionado.metodo);

      await api.put(`/metodos-pago/${metodoPagoSeleccionado.metodo}/imagen`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

    setRefreshMetodosPago(prev => prev + 1);

      setSnackbar({ 
        open: true, 
        message: `Imagen de ${metodoPagoSeleccionado.metodo.toUpperCase()} actualizada correctamente`, 
        severity: 'success' 
      });
      
      handleCloseMetodoPagoImagenDialog();
      cargarMetodosPagoImagenes(); // Recargar imágenes
    } catch (error) {
      console.error('Error subiendo imagen de método de pago:', error);
      setSnackbar({ 
        open: true, 
        message: 'Error al subir imagen: ' + (error.response?.data?.message || error.message), 
        severity: 'error' 
      });
    }
  };

  const handleEliminarImagenMetodoPago = async () => {
    if (!metodoPagoSeleccionado) return;

    try {
      await api.delete(`/metodos-pago/${metodoPagoSeleccionado.metodo}/imagen`);

      setSnackbar({ 
        open: true, 
        message: `Imagen de ${metodoPagoSeleccionado.metodo.toUpperCase()} eliminada correctamente`, 
        severity: 'success' 
      });
      
      handleCloseMetodoPagoImagenDialog();
      cargarMetodosPagoImagenes();
    } catch (error) {
      console.error('Error eliminando imagen de método de pago:', error);
      setSnackbar({ 
        open: true, 
        message: 'Error al eliminar imagen: ' + (error.response?.data?.message || error.message), 
        severity: 'error' 
      });
    }
  };

  // Obtener nombre legible del método de pago
  const getMetodoPagoNombre = (metodo) => {
    const nombres = {
      'efectivo': 'Efectivo',
      'transferencia': 'Transferencia',
      'tarjeta': 'Tarjeta',
      'yape': 'Yape',
      'plin': 'Plin'
    };
    return nombres[metodo] || metodo;
  };

  const getEstadoColor = (estado) => {
    switch (estado) {
      case 'pendiente': return 'warning';
      case 'aprobada': return 'success';
      case 'rechazada': return 'error';
      case 'convertida': return 'info';
      case 'procesando': return 'info';
      case 'completado': return 'success';
      case 'cancelado': return 'error';
      case 'emitida': return 'primary';
      case 'pagada': return 'success';
      case 'anulada': return 'error';
      case 'programada': return 'warning';
      case 'en_transito': return 'info';
      case 'entregada': return 'success';
      default: return 'default';
    }
  };

  const getTituloConversion = () => {
    switch (tipoConversion) {
      case 'pedido': return 'Convertir Cotización a Pedido';
      case 'factura': return formConversion.tipo_documento === 'boleta' ? 'Emitir Boleta' : 'Emitir Factura';
      case 'entrega': return 'Programar Entrega';
      default: return '';
    }
  };

  const getOpcionesEstado = () => {
    switch (tabValue) {
      case 0: return [
        <MenuItem key="" value="">Todos</MenuItem>,
        <MenuItem key="pendiente" value="pendiente">Pendiente</MenuItem>,
        <MenuItem key="aprobada" value="aprobada">Aprobada</MenuItem>,
        <MenuItem key="rechazada" value="rechazada">Rechazada</MenuItem>,
        <MenuItem key="convertida" value="convertida">Convertida</MenuItem>
      ];
      case 1: return [
        <MenuItem key="" value="">Todos</MenuItem>,
        <MenuItem key="pendiente" value="pendiente">Pendiente</MenuItem>,
        <MenuItem key="procesando" value="procesando">Procesando</MenuItem>,
        <MenuItem key="completado" value="completado">Completado</MenuItem>,
        <MenuItem key="cancelado" value="cancelado">Cancelado</MenuItem>
      ];
      case 2: return [
        <MenuItem key="" value="">Todos</MenuItem>,
        <MenuItem key="emitida" value="emitida">Emitida</MenuItem>,
        <MenuItem key="pagada" value="pagada">Pagada</MenuItem>,
        <MenuItem key="anulada" value="anulada">Anulada</MenuItem>
      ];
      case 3: return [
        <MenuItem key="" value="">Todos</MenuItem>,
        <MenuItem key="programada" value="programada">Programada</MenuItem>,
        <MenuItem key="en_transito" value="en_transito">En Tránsito</MenuItem>,
        <MenuItem key="entregada" value="entregada">Entregada</MenuItem>
      ];
      default: return [];
    }
  };

  const filtrarDatos = (datos) => {
    return datos.filter(item => {
      const texto = busqueda.toLowerCase();
      const coincideBusqueda = !busqueda || 
        item.codigo?.toLowerCase().includes(texto) ||
        item.cliente_nombre?.toLowerCase().includes(texto);
      const coincideEstado = !filtroEstado || item.estado === filtroEstado;
      return coincideBusqueda && coincideEstado;
    });
  };

  const datosActuales = () => {
    switch (tabValue) {
      case 0: return cotizaciones;
      case 1: return pedidos;
      case 2: return facturas;
      case 3: return entregas;
      default: return [];
    }
  };

  const productosFiltrados = productos.filter(prod => 
    prod.nombre.toLowerCase().includes(busquedaProducto.toLowerCase()) ||
    prod.codigo.toLowerCase().includes(busquedaProducto.toLowerCase())
  );

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
        <Typography variant="h4" sx={{ fontWeight: 'bold' }}>
          Ciclo de Ventas
        </Typography>
        <Box>
          {tabValue === 0 && (
            <Button
              variant="contained"
              startIcon={<AddIcon />}
              onClick={handleOpenCotizacion}
              sx={{ mr: 1, backgroundColor: '#1976d2' }}
            >
              Nueva Cotización
            </Button>
          )}

          <Button
            variant={cajaActual ? "contained" : "outlined"}
            color={cajaActual ? "success" : "warning"}
            onClick={() => setOpenCajaDialog(true)}
            sx={{ mr: 1 }}
          >
            {cajaActual ? '💰 Caja Abierta' : '🔒 Abrir Caja'}
          </Button>

          <Button
            variant="outlined"
            color="info"
            onClick={() => {
              cargarHistorialCajas();
              setOpenHistorial(true);
            }}
            sx={{ mr: 1 }}
          >
            📋 Historial
          </Button>

          <Button
            variant="outlined"
            startIcon={<PdfIcon />}
            onClick={() => {
              const data = datosActuales();
              let title = '', headers = [], filename = '';
              if (tabValue === 0) {
                title = 'Reporte de Cotizaciones';
                headers = ['Código', 'Cliente', 'Fecha', 'Total', 'Estado'];
                filename = `cotizaciones_${new Date().toISOString().split('T')[0]}`;
              } else if (tabValue === 1) {
                title = 'Reporte de Pedidos';
                headers = ['Código', 'Cliente', 'Fecha', 'Total', 'Estado'];
                filename = `pedidos_${new Date().toISOString().split('T')[0]}`;
              } else if (tabValue === 2) {
                title = 'Reporte de Facturas';
                headers = ['Código', 'Cliente', 'Fecha', 'Total', 'Estado'];
                filename = `facturas_${new Date().toISOString().split('T')[0]}`;
              } else {
                title = 'Reporte de Entregas';
                headers = ['Código', 'Pedido', 'Fecha', 'Estado'];
                filename = `entregas_${new Date().toISOString().split('T')[0]}`;
              }
              const rows = data.map(item => {
                if (tabValue === 3) return [item.codigo, item.pedido_codigo, new Date(item.fecha_entrega).toLocaleDateString('es-PE'), item.estado];
                return [item.codigo, item.cliente_nombre, new Date(item.fecha_cotizacion || item.fecha_pedido || item.fecha_emision).toLocaleDateString('es-PE'), `S/ ${parseFloat(item.total || 0).toFixed(2)}`, item.estado];
              });
              exportToPDF(title, headers, rows, filename);
            }}
            sx={{ mr: 1, color: '#d32f2f', borderColor: '#d32f2f' }}
          >
            PDF
          </Button>
          <Button
            variant="outlined"
            startIcon={<ExcelIcon />}
            onClick={() => {
              const data = datosActuales().map(item => {
                let fechaStr = '';
                const fechaRaw = item.fecha_cotizacion || item.fecha_pedido || item.fecha_emision || item.fecha_entrega;
                
                if (fechaRaw) {
                  const d = new Date(fechaRaw);
                  fechaStr = isNaN(d.getTime()) ? '' : d.toISOString().split('T')[0];
                }
                
                return {
                  'Código': item.codigo,
                  'Cliente': item.cliente_nombre || '-',
                  'Estado': item.estado,
                  'Total': item.total || '-',
                  'Fecha': fechaStr
                };
              });
              
              const sheets = ['Cotizaciones', 'Pedidos', 'Facturas', 'Entregas'];
              exportToExcel(data, `ventas_${new Date().toISOString().split('T')[0]}`, sheets[tabValue]);
            }}
            sx={{ mr: 1, color: '#388e3c', borderColor: '#388e3c' }}
          >
            Excel
          </Button>
        </Box>
      </Box>

      <Paper sx={{ mb: 3 }}>
        <Tabs value={tabValue} onChange={handleTabChange} variant="scrollable" scrollButtons="auto">
          <Tab label={`Cotizaciones (${cotizaciones.length})`} />
          <Tab label={`Pedidos (${pedidos.length})`} />
          <Tab label={`Facturas/Boletas (${facturas.length})`} />
          <Tab label={`Entregas (${entregas.length})`} />
        </Tabs>
      </Paper>

      {/* Filtros */}
      <Paper sx={{ p: 2, mb: 2 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid item xs={12} md={5}>
            <TextField
              fullWidth
              label="Buscar..."
              placeholder="Código o cliente"
              value={busqueda}
              onChange={(e) => setBusqueda(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={5}>
            <TextField
              fullWidth
              select
              label="Estado"
              value={filtroEstado}
              onChange={(e) => setFiltroEstado(e.target.value)}
            >
              {getOpcionesEstado()}
            </TextField>
          </Grid>
          <Grid item xs={12} md={2}>
            <Button 
              fullWidth 
              variant="outlined" 
              onClick={() => { setBusqueda(''); setFiltroEstado(''); }}
            >
              Limpiar
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {/* COTIZACIONES */}
      {tabValue === 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#1976d2' }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Código</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Cliente</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Total</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Estado</TableCell>
                <TableCell> </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtrarDatos(cotizaciones).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography sx={{ py: 3 }}>No hay cotizaciones registradas</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filtrarDatos(cotizaciones).map((cot) => (
                  <TableRow key={cot.id} hover>
                    <TableCell>{cot.codigo}</TableCell>
                    <TableCell>{cot.cliente_nombre}</TableCell>
                    <TableCell>{new Date(cot.fecha_cotizacion).toLocaleDateString('es-PE')}</TableCell>
                    <TableCell>S/ {parseFloat(cot.total).toFixed(2)}</TableCell>
                    <TableCell>
                      <Chip label={cot.estado} color={getEstadoColor(cot.estado)} size="small" />
                    </TableCell>
                    <TableCell>
                      {cot.estado === 'pendiente' && (
                        <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                          <IconButton size="small" color="primary" onClick={() => generarPDFCotizacion(cot)} title="Ver PDF">
                            <ViewIcon />
                          </IconButton>
                          <IconButton size="small" color="info" onClick={() => handleEditarCotizacion(cot)} title="Editar">
                            <EditIcon />
                          </IconButton>
                          <IconButton size="small" color="error" onClick={() => handleOpenEliminar(cot)} title="Eliminar">
                            <DeleteIcon />
                          </IconButton>
                          <Button size="small" variant="contained" color="success" startIcon={<ArrowIcon />} onClick={() => handleConvertirAPedido(cot)}>
                            A Pedido
                          </Button>
                        </Box>
                      )}
                      {cot.estado === 'anulada' && (
                        <Chip label="Anulada" color="error" size="small" variant="outlined" />
                      )}
                      {cot.estado === 'convertida' && (
                        <Chip label="Convertida" color="info" size="small" variant="outlined" />
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* PEDIDOS */}
      {tabValue === 1 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#388e3c' }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Código</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Cliente</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Total</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Estado</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtrarDatos(pedidos).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} align="center">
                    <Typography sx={{ py: 3 }}>No hay pedidos registrados</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filtrarDatos(pedidos).map((ped) => (
                  <TableRow key={ped.id} hover>
                    <TableCell>{ped.codigo}</TableCell>
                    <TableCell>{ped.cliente_nombre}</TableCell>
                    <TableCell>{new Date(ped.fecha_pedido).toLocaleDateString('es-PE')}</TableCell>
                    <TableCell>S/ {parseFloat(ped.total).toFixed(2)}</TableCell>
                    <TableCell>
                      <Chip label={ped.estado} color={getEstadoColor(ped.estado)} size="small" />
                    </TableCell>
                    <TableCell>
                      {ped.estado === 'pendiente' && (
                        <Button size="small" variant="contained" color="warning" startIcon={<ArrowIcon />} onClick={() => handleConvertirAFactura(ped)}>
                          Facturar/Boleta
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* FACTURAS */}
      {tabValue === 2 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#f57c00' }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Código</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Cliente</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Tipo</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Total</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Estado</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtrarDatos(facturas).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={7} align="center">
                    <Typography sx={{ py: 3 }}>No hay documentos registrados</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filtrarDatos(facturas).map((fac) => (
                  <TableRow key={fac.id} hover>
                    <TableCell>{fac.codigo}</TableCell>
                    <TableCell>{fac.cliente_nombre}</TableCell>
                    <TableCell>
                      <Chip 
                        label={fac.tipo_documento === 'boleta' ? 'Boleta' : 'Factura'} 
                        color={fac.tipo_documento === 'boleta' ? 'warning' : 'primary'} 
                        size="small" 
                        variant="outlined"
                      />
                    </TableCell>
                    <TableCell>{new Date(fac.fecha_emision).toLocaleDateString('es-PE')}</TableCell>
                    <TableCell>S/ {parseFloat(fac.total).toFixed(2)}</TableCell>
                    <TableCell>
                      <Chip label={fac.estado} color={getEstadoColor(fac.estado)} size="small" />
                    </TableCell>
                    <TableCell>
                      {fac.estado === 'emitida' && (
                        <Button size="small" variant="contained" color="secondary" startIcon={<ArrowIcon />} onClick={() => handleProgramarEntrega(fac)}>
                          Entregar
                        </Button>
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* ENTREGAS */}
      {tabValue === 3 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: '#7b1fa2' }}>
              <TableRow>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Código</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Pedido</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Fecha Entrega</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Estado</TableCell>
                <TableCell sx={{ color: 'white', fontWeight: 'bold' }}>Acciones</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtrarDatos(entregas).length === 0 ? (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    <Typography sx={{ py: 3 }}>No hay entregas registradas</Typography>
                  </TableCell>
                </TableRow>
              ) : (
                filtrarDatos(entregas).map((ent) => (
                  <TableRow key={ent.id} hover>
                    <TableCell>{ent.codigo}</TableCell>
                    <TableCell>{ent.pedido_codigo}</TableCell>
                    <TableCell>{new Date(ent.fecha_entrega).toLocaleDateString('es-PE')}</TableCell>
                    <TableCell>
                      <Chip label={ent.estado} color={getEstadoColor(ent.estado)} size="small" />
                    </TableCell>
                    <TableCell>
                      {ent.estado === 'programada' && (
                        <Button
                          size="small"
                          variant="contained"
                          color="primary"
                          startIcon={<ReceiptIcon />}
                          onClick={() => generarFacturaPDF(ent)}
                        >
                          Generar Factura
                        </Button>
                      )}
                      {ent.estado === 'entregada' && (
                        <Chip label="Completado" color="success" size="small" variant="outlined" />
                      )}
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Dialog de Historial de Caja */}
      <Dialog open={openHistorial} onClose={() => setOpenHistorial(false)} maxWidth="md" fullWidth>
        <DialogTitle>Historial de Cajas</DialogTitle>
        <DialogContent>
          {historialCajas.length === 0 ? (
            <Typography color="text.secondary" sx={{ py: 3, textAlign: 'center' }}>
              No hay registros de cajas
            </Typography>
          ) : (
            <TableContainer component={Paper} sx={{ mt: 2 }}>
              <Table size="small">
                <TableHead>
                  <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                    <TableCell><strong>ID</strong></TableCell>
                    <TableCell><strong>Fecha Apertura</strong></TableCell>
                    <TableCell><strong>Fecha Cierre</strong></TableCell>
                    <TableCell align="right"><strong>Monto Apertura</strong></TableCell>
                    <TableCell align="right"><strong>Total Ventas</strong></TableCell>
                    <TableCell align="right"><strong>Monto Cierre</strong></TableCell>
                    <TableCell align="right"><strong>Diferencia</strong></TableCell>
                    <TableCell><strong>Estado</strong></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {historialCajas.map((caja) => (
                    <TableRow key={caja.id}>
                      <TableCell>{caja.id}</TableCell>
                      <TableCell>
                        {caja.fecha_apertura 
                          ? new Date(caja.fecha_apertura).toLocaleString('es-PE') 
                          : '-'}
                      </TableCell>
                      <TableCell>
                        {caja.fecha_cierre 
                          ? new Date(caja.fecha_cierre).toLocaleString('es-PE') 
                          : <span style={{ color: '#4caf50' }}>Abierta</span>}
                      </TableCell>
                      <TableCell align="right">S/ {parseFloat(caja.monto_apertura || 0).toFixed(2)}</TableCell>
                      <TableCell align="right">S/ {parseFloat(caja.total_ventas || 0).toFixed(2)}</TableCell>
                      <TableCell align="right">
                        {caja.monto_cierre 
                          ? `S/ ${parseFloat(caja.monto_cierre).toFixed(2)}` 
                          : '-'}
                      </TableCell>
                      <TableCell align="right" sx={{ 
                        color: (caja.diferencia || 0) < 0 ? '#d32f2f' : (caja.diferencia || 0) > 0 ? '#4caf50' : 'inherit',
                        fontWeight: 'bold'
                      }}>
                        {caja.diferencia !== null 
                          ? `S/ ${parseFloat(caja.diferencia).toFixed(2)}` 
                          : '-'}
                      </TableCell>
                      <TableCell>
                        <span style={{ 
                          color: caja.estado === 'abierta' ? '#4caf50' : '#1976d2',
                          fontWeight: 'bold'
                        }}>
                          {caja.estado === 'abierta' ? '🔓 Abierta' : '🔒 Cerrada'}
                        </span>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenHistorial(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog de Apertura/Cierre de Caja */}
      <Dialog open={openCajaDialog} onClose={() => setOpenCajaDialog(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: cajaActual ? '#d32f2f' : '#1976d2', fontWeight: 'bold' }}>
          {cajaActual ? 'Cerrar Caja' : 'Abrir Caja'}
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            {!cajaActual ? (
              <>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Monto de Apertura (S/)"
                    value={montoApertura}
                    onChange={(e) => setMontoApertura(e.target.value)}
                    required
                    autoFocus
                  />
                </Grid>
              </>
            ) : (
              <>
                <Grid item xs={12}>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    <strong>Monto de Apertura:</strong> S/ {parseFloat(cajaActual.monto_apertura).toFixed(2)}
                  </Typography>
                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    <strong>Total Ventas del Día:</strong> S/ {parseFloat(cajaActual.ventas_hoy?.total_ventas || 0).toFixed(2)}
                  </Typography>
                  <Typography variant="subtitle1" sx={{ mb: 2, color: 'primary.main' }}>
                    <strong>Monto Esperado:</strong> S/ {(parseFloat(cajaActual.monto_apertura) + parseFloat(cajaActual.ventas_hoy?.total_ventas || 0)).toFixed(2)}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    type="number"
                    label="Monto de Cierre (S/)"
                    value={montoCierre}
                    onChange={(e) => setMontoCierre(e.target.value)}
                    required
                    autoFocus
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <TextField
                fullWidth
                multiline
                rows={2}
                label="Observaciones"
                value={observacionesCaja}
                onChange={(e) => setObservacionesCaja(e.target.value)}
              />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenCajaDialog(false)} color="inherit">
            Cancelar
          </Button>
          <Button
            onClick={cajaActual ? handleCerrarCaja : handleAbrirCaja}
            variant="contained"
            color={cajaActual ? 'error' : 'primary'}
            disabled={cajaActual ? !montoCierre : !montoApertura}
          >
            {cajaActual ? 'Cerrar Caja' : 'Abrir Caja'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Nueva Cotización */}
      <Dialog open={openDialog} onClose={() => setOpenDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          Nueva Cotización
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Código" value={formCotizacion.codigo} InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField 
                fullWidth 
                select 
                label="Cliente *" 
                value={formCotizacion.cliente_id} 
                onChange={(e) => setFormCotizacion({...formCotizacion, cliente_id: e.target.value})} 
                required
              >
                {clientes.map((cli) => (<MenuItem key={cli.id} value={cli.id}>{cli.nombre}</MenuItem>))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField 
                fullWidth 
                type="date" 
                label="Fecha *" 
                value={formCotizacion.fecha_cotizacion} 
                onChange={(e) => setFormCotizacion({...formCotizacion, fecha_cotizacion: e.target.value})} 
                InputLabelProps={{ shrink: true }} 
                required
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Productos</Typography>
              
              {/* Preview de imagen del producto seleccionado */}
              {imagenPreview && (
                <Box sx={{ mb: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                  {imagenPreview.url ? (
                    <img 
                      src={imagenPreview.url} 
                      alt={imagenPreview.nombre}
                      style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 8, border: '2px solid #1976d2' }}
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                  ) : (
                    <Box sx={{ 
                      width: 120, 
                      height: 120, 
                      backgroundColor: '#e0e0e0', 
                      borderRadius: 2, 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      border: '2px dashed #1976d2'
                    }}>
                      <Typography variant="caption" color="text.secondary" align="center">
                        Sin imagen
                      </Typography>
                    </Box>
                  )}
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                      {imagenPreview.nombre}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Producto seleccionado
                    </Typography>
                    
                    {/* BOTONES DE GESTIÓN DE IMAGEN - SOLO ADMIN */}
                    {isAdmin() && (
                      <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
                        {!imagenPreview.url ? (
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            startIcon={<AddPhotoIcon />}
                            onClick={() => {
                              const prod = productos.find(p => p.id === imagenPreview.producto_id);
                              if (prod) handleOpenImagenDialog(prod);
                            }}
                          >
                            Agregar Imagen
                          </Button>
                        ) : (
                          <>
                            <Button
                              size="small"
                              variant="outlined"
                              color="primary"
                              startIcon={<CameraIcon />}
                              onClick={() => {
                                const prod = productos.find(p => p.id === imagenPreview.producto_id);
                                if (prod) handleOpenImagenDialog(prod);
                              }}
                            >
                              Cambiar
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              color="error"
                              startIcon={<DeletePhotoIcon />}
                              onClick={() => {
                                const prod = productos.find(p => p.id === imagenPreview.producto_id);
                                if (prod) {
                                  setProductoImagen(prod);
                                  handleEliminarImagen();
                                }
                              }}
                            >
                              Eliminar
                            </Button>
                          </>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
              
              {formCotizacion.items.map((item, index) => (
                <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
                  <Grid item xs={12} md={5}>
                    <FormControl fullWidth required>
                      <InputLabel id={`producto-label-${index}`}>Producto {index + 1} *</InputLabel>
                      <Select
                        labelId={`producto-label-${index}`}
                        value={item.producto_id}
                        onChange={(e) => {
                          handleItemChange(index, 'producto_id', e.target.value);
                          setBusquedaProducto('');
                        }}
                        input={<OutlinedInput label={`Producto ${index + 1} *`} />}
                        renderValue={(selected) => {
                          const prod = productos.find(p => p.id === selected);
                          return prod ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              {prod.imagen && (
                                <img 
                                  src={`${API_BASE}${prod.imagen}`} 
                                  alt={prod.nombre}
                                  style={{ width: 24, height: 24, objectFit: 'cover', borderRadius: 4 }}
                                  onError={(e) => { e.target.style.display = 'none'; }}
                                />
                              )}
                              <span>{prod.codigo} - {prod.nombre} (S/ {prod.precio_venta})</span>
                            </Box>
                          ) : '';
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: { maxHeight: 400 }
                          }
                        }}
                      >
                        <Box sx={{ p: 1.5, position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1, borderBottom: '1px solid #e0e0e0' }}>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="Buscar producto..."
                            value={busquedaProducto}
                            onChange={(e) => setBusquedaProducto(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            onKeyDown={(e) => e.stopPropagation()}
                            autoFocus
                            InputProps={{
                              startAdornment: (
                                <Box component="span" sx={{ color: 'text.secondary', mr: 1 }}>🔍</Box>
                              )
                            }}
                          />
                          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                            {productosFiltrados.length} producto(s) encontrado(s)
                          </Typography>
                        </Box>
                        {productosFiltrados.length === 0 ? (
                          <MenuItem disabled>
                            <Typography variant="body2" color="text.secondary">No se encontraron productos</Typography>
                          </MenuItem>
                        ) : (
                          productosFiltrados.map((prod) => (
                            <MenuItem key={prod.id} value={prod.id}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                {prod.imagen ? (
                                  <img 
                                    src={`${API_BASE}${prod.imagen}`}
                                    alt={prod.nombre}
                                    style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4, border: '1px solid #e0e0e0' }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                  />
                                ) : (
                                  <Box sx={{ width: 40, height: 40, backgroundColor: '#f5f5f5', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography variant="caption" color="text.secondary">Sin img</Typography>
                                  </Box>
                                )}
                                <Box>
                                  <Typography variant="body2">{prod.codigo} - {prod.nombre}</Typography>
                                  <Typography variant="caption" color="primary">S/ {prod.precio_venta}</Typography>
                                </Box>
                              </Box>
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField 
                      fullWidth 
                      type="number" 
                      label="Cantidad *" 
                      value={item.cantidad} 
                      onChange={(e) => handleItemChange(index, 'cantidad', e.target.value)} 
                      required 
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField 
                      fullWidth 
                      type="number" 
                      label="Precio Unitario" 
                      value={item.precio_unitario} 
                      InputProps={{ readOnly: true }}
                      helperText="Precio con IGV incluido"
                      sx={{ backgroundColor: '#f5f5f5' }}
                    />
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <Button color="error" onClick={() => handleRemoveItem(index)} disabled={formCotizacion.items.length === 1}>X</Button>
                  </Grid>
                </Grid>
              ))}
              <Button onClick={handleAddItem} variant="outlined" sx={{ mb: 2 }}>+ Agregar Producto</Button>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ textAlign: 'right', p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                <Typography>Op. Gravada: S/ {calcularTotal().subtotal.toFixed(2)}</Typography>
                <Typography>IGV (18%): S/ {calcularTotal().igv.toFixed(2)}</Typography>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2' }}>Importe Total: S/ {calcularTotal().total.toFixed(2)}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline rows={2} label="Observaciones" value={formCotizacion.observaciones} onChange={(e) => setFormCotizacion({...formCotizacion, observaciones: e.target.value})} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDialog(false)} color="inherit">Cancelar</Button>
          <Button onClick={handleSubmitCotizacion} variant="contained" sx={{ backgroundColor: '#1976d2' }}>Guardar Cotización</Button>
        </DialogActions>
      </Dialog>

      {/* ============================================
          DIALOG DE CONVERSIÓN (FACTURA/PEDIDO/ENTREGA)
          CON IMÁGENES DE MÉTODOS DE PAGO
          ============================================ */}
      <Dialog open={openConvertir} onClose={() => setOpenConvertir(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: '#1976d2', fontWeight: 'bold' }}>{getTituloConversion()}</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12}>
              <TextField 
                fullWidth 
                label="Código *" 
                value={formConversion.codigo} 
                onChange={(e) => setFormConversion({...formConversion, codigo: e.target.value})} 
                required 
              />
            </Grid>
            {tipoConversion === 'pedido' && (
              <Grid item xs={12}>
                <TextField 
                  fullWidth 
                  type="date" 
                  label="Fecha de Entrega Estimada *" 
                  value={formConversion.fecha} 
                  onChange={(e) => setFormConversion({...formConversion, fecha: e.target.value})} 
                  InputLabelProps={{ shrink: true }} 
                  required 
                />
              </Grid>
            )}
            {tipoConversion === 'factura' && (
              <>
                <Grid item xs={12} md={4}>
                  <TextField 
                    fullWidth 
                    type="date" 
                    label="Fecha de Vencimiento *" 
                    value={formConversion.fecha} 
                    onChange={(e) => setFormConversion({...formConversion, fecha: e.target.value})} 
                    InputLabelProps={{ shrink: true }} 
                    required 
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField 
                    fullWidth 
                    select 
                    label="Tipo de Documento" 
                    value={formConversion.tipo_documento || 'factura'} 
                    onChange={(e) => setFormConversion({...formConversion, tipo_documento: e.target.value})}
                  >
                    <MenuItem value="factura">Factura</MenuItem>
                    <MenuItem value="boleta">Boleta</MenuItem>
                  </TextField>
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField 
                    fullWidth 
                    select 
                    label="Método de Pago" 
                    value={formConversion.metodo_pago} 
                    onChange={(e) => setFormConversion({...formConversion, metodo_pago: e.target.value})}
                  >
                    <MenuItem value="efectivo">Efectivo</MenuItem>
                    <MenuItem value="transferencia">Transferencia</MenuItem>
                    <MenuItem value="tarjeta">Tarjeta</MenuItem>
                    <MenuItem value="yape">Yape</MenuItem>
                    <MenuItem value="plin">Plin</MenuItem>
                  </TextField>
                </Grid>
                
                {/* ============================================
                    VISTA PREVIA DE IMAGEN DEL MÉTODO DE PAGO
                    ============================================ */}
                {tipoConversion === 'factura' && (
                  <Grid item xs={12}>
                    <Box sx={{ 
                      p: 2, 
                      backgroundColor: '#f8f9fa', 
                      borderRadius: 2, 
                      border: '1px solid #e0e0e0',
                      textAlign: 'center'
                    }}>
                      <Typography variant="subtitle2" sx={{ mb: 1, color: '#1976d2', fontWeight: 'bold' }}>
                        Método de Pago: {getMetodoPagoNombre(formConversion.metodo_pago)}
                      </Typography>
                      
                      {metodosPagoImagenes[formConversion.metodo_pago] ? (
                        <Box sx={{ position: 'relative', display: 'inline-block' }}>
                          <img 
                            src={`http://localhost:5000${metodosPagoImagenes[formConversion.metodo_pago]}`} 
                            alt={getMetodoPagoNombre(formConversion.metodo_pago)}
                            style={{ 
                              maxWidth: '100%', 
                              maxHeight: 250, 
                              objectFit: 'contain', 
                              borderRadius: 8,
                              border: '2px solid #1976d2'
                            }}
                            onError={(e) => { e.target.style.display = 'none'; }}
                          />
                        </Box>
                      ) : (
                        <Box sx={{ 
                          width: '100%', 
                          height: 150, 
                          backgroundColor: '#e9ecef', 
                          borderRadius: 2, 
                          display: 'flex', 
                          flexDirection: 'column',
                          alignItems: 'center', 
                          justifyContent: 'center',
                          border: '2px dashed #adb5bd',
                          gap: 1
                        }}>
                          <Typography variant="body2" color="text.secondary">
                            No hay imagen configurada para {getMetodoPagoNombre(formConversion.metodo_pago)}
                          </Typography>
                          <Typography variant="caption" color="text.secondary">
                            {formConversion.metodo_pago === 'efectivo' 
                              ? 'Pago en efectivo no requiere imagen' 
                              : 'Sube un QR o imagen representativa'}
                          </Typography>
                        </Box>
                      )}
                      
                      {/* BOTONES DE GESTIÓN DE IMAGEN - SOLO ADMIN */}
                      {isAdmin() && (
                        <Box sx={{ mt: 2, display: 'flex', justifyContent: 'center', gap: 1 }}>
                          {!metodosPagoImagenes[formConversion.metodo_pago] ? (
                            <Button
                              size="small"
                              variant="outlined"
                              color="primary"
                              startIcon={<AddPhotoIcon />}
                              onClick={() => handleOpenMetodoPagoImagenDialog(formConversion.metodo_pago)}
                            >
                              Agregar Imagen
                            </Button>
                          ) : (
                            <>
                              <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                startIcon={<CameraIcon />}
                                onClick={() => handleOpenMetodoPagoImagenDialog(formConversion.metodo_pago)}
                              >
                                Cambiar Imagen
                              </Button>
                              <Button
                                size="small"
                                variant="outlined"
                                color="error"
                                startIcon={<DeletePhotoIcon />}
                                onClick={() => {
                                  setMetodoPagoSeleccionado({
                                    metodo: formConversion.metodo_pago,
                                    imagen: metodosPagoImagenes[formConversion.metodo_pago]
                                  });
                                  handleEliminarImagenMetodoPago();
                                }}
                              >
                                Eliminar Imagen
                              </Button>
                            </>
                          )}
                        </Box>
                      )}
                    </Box>
                  </Grid>
                )}
              </>
            )}
            {tipoConversion === 'entrega' && (
              <>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    type="date" 
                    label="Fecha de Entrega *" 
                    value={formConversion.fecha} 
                    onChange={(e) => setFormConversion({...formConversion, fecha: e.target.value})} 
                    InputLabelProps={{ shrink: true }} 
                    required 
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Dirección de Entrega *" 
                    value={formConversion.direccion_entrega} 
                    onChange={(e) => setFormConversion({...formConversion, direccion_entrega: e.target.value})} 
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField 
                    fullWidth 
                    label="Responsable de Recepción *" 
                    value={formConversion.responsable} 
                    onChange={(e) => setFormConversion({...formConversion, responsable: e.target.value})} 
                    required
                  />
                </Grid>
              </>
            )}
            <Grid item xs={12}>
              <TextField fullWidth multiline rows={2} label="Observaciones" value={formConversion.observaciones} onChange={(e) => setFormConversion({...formConversion, observaciones: e.target.value})} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenConvertir(false)} color="inherit">Cancelar</Button>
          <Button onClick={handleSubmitConversion} variant="contained" sx={{ backgroundColor: '#1976d2' }}>Confirmar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Editar Cotización */}
      <Dialog open={openEditarCotizacion} onClose={() => setOpenEditarCotizacion(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          Editar Cotización
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 1 }}>
            <Grid item xs={12} md={4}>
              <TextField fullWidth label="Código" value={formCotizacion.codigo} InputProps={{ readOnly: true }} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField 
                fullWidth 
                select 
                label="Cliente *" 
                value={formCotizacion.cliente_id} 
                onChange={(e) => setFormCotizacion({...formCotizacion, cliente_id: e.target.value})} 
                required
              >
                {clientes.map((cli) => (<MenuItem key={cli.id} value={cli.id}>{cli.nombre}</MenuItem>))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField 
                fullWidth 
                type="date" 
                label="Fecha *" 
                value={formCotizacion.fecha_cotizacion} 
                onChange={(e) => setFormCotizacion({...formCotizacion, fecha_cotizacion: e.target.value})} 
                InputLabelProps={{ shrink: true }} 
                required
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <TextField fullWidth type="date" label="Vencimiento" value={formCotizacion.fecha_vencimiento || ''} onChange={(e) => setFormCotizacion({...formCotizacion, fecha_vencimiento: e.target.value})} InputLabelProps={{ shrink: true }} />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>Productos</Typography>
              
              {/* Preview de imagen en edición */}
              {imagenPreview && (
                <Box sx={{ mb: 2, p: 2, backgroundColor: '#f5f5f5', borderRadius: 2, display: 'flex', alignItems: 'center', gap: 2, flexWrap: 'wrap' }}>
                  {imagenPreview.url ? (
                    <img 
                      src={imagenPreview.url} 
                      alt={imagenPreview.nombre}
                      style={{ width: 120, height: 120, objectFit: 'cover', borderRadius: 8, border: '2px solid #1976d2' }}
                      onError={(e) => { e.target.style.display = 'none'; }}
                    />
                  ) : (
                    <Box sx={{ 
                      width: 120, 
                      height: 120, 
                      backgroundColor: '#e0e0e0', 
                      borderRadius: 2, 
                      display: 'flex', 
                      alignItems: 'center', 
                      justifyContent: 'center',
                      border: '2px dashed #1976d2'
                    }}>
                      <Typography variant="caption" color="text.secondary" align="center">
                        Sin imagen
                      </Typography>
                    </Box>
                  )}
                  <Box sx={{ flex: 1 }}>
                    <Typography variant="subtitle1" sx={{ color: '#1976d2', fontWeight: 'bold' }}>
                      {imagenPreview.nombre}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      Producto seleccionado
                    </Typography>
                    
                    {isAdmin() && (
                      <Box sx={{ mt: 1, display: 'flex', gap: 1 }}>
                        {!imagenPreview.url ? (
                          <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            startIcon={<AddPhotoIcon />}
                            onClick={() => {
                              const prod = productos.find(p => p.id === imagenPreview.producto_id);
                              if (prod) handleOpenImagenDialog(prod);
                            }}
                          >
                            Agregar Imagen
                          </Button>
                        ) : (
                          <>
                            <Button
                              size="small"
                              variant="outlined"
                              color="primary"
                              startIcon={<CameraIcon />}
                              onClick={() => {
                                const prod = productos.find(p => p.id === imagenPreview.producto_id);
                                if (prod) handleOpenImagenDialog(prod);
                              }}
                            >
                              Cambiar
                            </Button>
                            <Button
                              size="small"
                              variant="outlined"
                              color="error"
                              startIcon={<DeletePhotoIcon />}
                              onClick={() => {
                                const prod = productos.find(p => p.id === imagenPreview.producto_id);
                                if (prod) {
                                  setProductoImagen(prod);
                                  handleEliminarImagen();
                                }
                              }}
                            >
                              Eliminar
                            </Button>
                          </>
                        )}
                      </Box>
                    )}
                  </Box>
                </Box>
              )}
              
              {formCotizacion.items.map((item, index) => (
                <Grid container spacing={2} key={index} sx={{ mb: 2 }}>
                  <Grid item xs={12} md={5}>
                    <FormControl fullWidth required>
                      <InputLabel id={`producto-label-edit-${index}`}>Producto {index + 1} *</InputLabel>
                      <Select
                        labelId={`producto-label-edit-${index}`}
                        value={item.producto_id}
                        onChange={(e) => {
                          handleItemChange(index, 'producto_id', e.target.value);
                          setBusquedaProducto('');
                        }}
                        input={<OutlinedInput label={`Producto ${index + 1} *`} />}
                        renderValue={(selected) => {
                          const prod = productos.find(p => p.id === selected);
                          return prod ? (
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                              {prod.imagen && (
                                <img 
                                  src={`${API_BASE}${prod.imagen}`}
                                  alt={prod.nombre}
                                  style={{ width: 24, height: 24, objectFit: 'cover', borderRadius: 4 }}
                                  onError={(e) => { e.target.style.display = 'none'; }}
                                />
                              )}
                              <span>{prod.codigo} - {prod.nombre} (S/ {prod.precio_venta})</span>
                            </Box>
                          ) : '';
                        }}
                        MenuProps={{
                          PaperProps: {
                            style: { maxHeight: 400 }
                          }
                        }}
                      >
                        <Box sx={{ p: 1.5, position: 'sticky', top: 0, backgroundColor: 'white', zIndex: 1, borderBottom: '1px solid #e0e0e0' }}>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="Buscar producto..."
                            value={busquedaProducto}
                            onChange={(e) => setBusquedaProducto(e.target.value)}
                            onClick={(e) => e.stopPropagation()}
                            onKeyDown={(e) => e.stopPropagation()}
                            autoFocus
                            InputProps={{
                              startAdornment: (
                                <Box component="span" sx={{ color: 'text.secondary', mr: 1 }}>🔍</Box>
                              )
                            }}
                          />
                          <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                            {productosFiltrados.length} producto(s) encontrado(s)
                          </Typography>
                        </Box>
                        {productosFiltrados.length === 0 ? (
                          <MenuItem disabled>
                            <Typography variant="body2" color="text.secondary">No se encontraron productos</Typography>
                          </MenuItem>
                        ) : (
                          productosFiltrados.map((prod) => (
                            <MenuItem key={prod.id} value={prod.id}>
                              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                {prod.imagen ? (
                                  <img 
                                    src={`http://localhost:5000${prod.imagen}`} 
                                    alt={prod.nombre}
                                    style={{ width: 40, height: 40, objectFit: 'cover', borderRadius: 4, border: '1px solid #e0e0e0' }}
                                    onError={(e) => { e.target.style.display = 'none'; }}
                                  />
                                ) : (
                                  <Box sx={{ width: 40, height: 40, backgroundColor: '#f5f5f5', borderRadius: 1, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <Typography variant="caption" color="text.secondary">Sin img</Typography>
                                  </Box>
                                )}
                                <Box>
                                  <Typography variant="body2">{prod.codigo} - {prod.nombre}</Typography>
                                  <Typography variant="caption" color="primary">S/ {prod.precio_venta}</Typography>
                                </Box>
                              </Box>
                            </MenuItem>
                          ))
                        )}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField 
                      fullWidth 
                      type="number" 
                      label="Cantidad *" 
                      value={item.cantidad} 
                      onChange={(e) => handleItemChange(index, 'cantidad', e.target.value)} 
                      required 
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField 
                      fullWidth 
                      type="number" 
                      label="Precio Unitario" 
                      value={item.precio_unitario} 
                      InputProps={{ readOnly: true }}
                      helperText="Precio con IGV incluido"
                      sx={{ backgroundColor: '#f5f5f5' }}
                    />
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <Button color="error" onClick={() => handleRemoveItem(index)} disabled={formCotizacion.items.length === 1}>X</Button>
                  </Grid>
                </Grid>
              ))}
              <Button onClick={handleAddItem} variant="outlined" sx={{ mb: 2 }}>+ Agregar Producto</Button>
            </Grid>
            <Grid item xs={12}>
              <Box sx={{ textAlign: 'right', p: 2, backgroundColor: '#f5f5f5', borderRadius: 1 }}>
                <Typography>Op. Gravada: S/ {calcularTotal().subtotal.toFixed(2)}</Typography>
                <Typography>IGV (18%): S/ {calcularTotal().igv.toFixed(2)}</Typography>
                <Typography variant="h6" sx={{ fontWeight: 'bold', color: '#1976d2' }}>Importe Total: S/ {calcularTotal().total.toFixed(2)}</Typography>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <TextField fullWidth multiline rows={2} label="Observaciones" value={formCotizacion.observaciones} onChange={(e) => setFormCotizacion({...formCotizacion, observaciones: e.target.value})} />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEditarCotizacion(false)} color="inherit">Cancelar</Button>
          <Button onClick={handleUpdateCotizacion} variant="contained" sx={{ backgroundColor: '#1976d2' }}>Actualizar</Button>
        </DialogActions>
      </Dialog>

      {/* Dialog Eliminar Cotización */}
      <Dialog open={openEliminarCotizacion} onClose={() => setOpenEliminarCotizacion(false)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: '#d32f2f', fontWeight: 'bold' }}>Anular Cotización</DialogTitle>
        <DialogContent>
          <Typography>¿Estás seguro de anular la cotización <strong>{cotizacionEliminar?.codigo}</strong>?</Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 1}}>Solo se pueden anular cotizaciones en estado pendiente.</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenEliminarCotizacion(false)} color="inherit">Cancelar</Button>
          <Button onClick={handleEliminarCotizacion} variant="contained" color="error">Anular</Button>
        </DialogActions>
      </Dialog>

      {/* ============================================
          DIALOG DE GESTIÓN DE IMÁGENES DE PRODUCTO
          ============================================ */}
      <Dialog open={openImagenDialog} onClose={handleCloseImagenDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          {productoImagen?.imagen ? 'Cambiar Imagen' : 'Agregar Imagen'} - {productoImagen?.nombre}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            {productoImagen?.imagen && !archivoImagen && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Imagen actual:</Typography>
                <img 
                  src={`http://localhost:5000${productoImagen.imagen}`} 
                  alt={productoImagen.nombre}
                  style={{ maxWidth: '100%', maxHeight: 200, objectFit: 'contain', borderRadius: 8, border: '1px solid #e0e0e0' }}
                />
              </Box>
            )}
            
            {archivoImagen && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Nueva imagen:</Typography>
                <img 
                  src={URL.createObjectURL(archivoImagen)} 
                  alt="Preview"
                  style={{ maxWidth: '100%', maxHeight: 200, objectFit: 'contain', borderRadius: 8, border: '1px solid #e0e0e0' }}
                />
              </Box>
            )}
            
            <input
              type="file"
              accept="image/jpeg,image/png,image/webp,image/jpg"
              ref={fileInputRef}
              style={{ display: 'none' }}
              onChange={handleSeleccionarImagen}
            />
            
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddPhotoIcon />}
              onClick={() => fileInputRef.current?.click()}
              fullWidth
            >
              {archivoImagen ? 'Cambiar archivo' : 'Seleccionar imagen'}
            </Button>
            
            {archivoImagen && (
              <Typography variant="caption" color="text.secondary">
                {archivoImagen.name} ({(archivoImagen.size / 1024).toFixed(1)} KB)
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseImagenDialog} color="inherit">Cancelar</Button>
          
          {productoImagen?.imagen && (
            <Button 
              onClick={handleEliminarImagen} 
              color="error" 
              variant="outlined"
              startIcon={<DeletePhotoIcon />}
            >
              Eliminar Imagen
            </Button>
          )}
          
          <Button 
            onClick={handleSubirImagen} 
            variant="contained" 
            color="primary"
            disabled={!archivoImagen}
            startIcon={<AddPhotoIcon />}
          >
            {productoImagen?.imagen ? 'Actualizar' : 'Subir'}
          </Button>
        </DialogActions>
      </Dialog>

      {/* ============================================
          DIALOG DE GESTIÓN DE IMÁGENES DE MÉTODOS DE PAGO
          ============================================ */}
      <Dialog open={openMetodoPagoImagenDialog} onClose={handleCloseMetodoPagoImagenDialog} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ color: '#1976d2', fontWeight: 'bold' }}>
          {metodoPagoSeleccionado?.imagen ? 'Cambiar Imagen' : 'Agregar Imagen'} - {getMetodoPagoNombre(metodoPagoSeleccionado?.metodo)}
        </DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
            {metodoPagoSeleccionado?.imagen && !archivoMetodoPago && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Imagen actual:</Typography>
                <img 
                  src={`http://localhost:5000${metodoPagoSeleccionado.imagen}`} 
                  alt={getMetodoPagoNombre(metodoPagoSeleccionado.metodo)}
                  style={{ maxWidth: '100%', maxHeight: 250, objectFit: 'contain', borderRadius: 8, border: '1px solid #e0e0e0' }}
                />
              </Box>
            )}
            
            {archivoMetodoPago && (
              <Box sx={{ textAlign: 'center' }}>
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Nueva imagen:</Typography>
                <img 
                  src={URL.createObjectURL(archivoMetodoPago)} 
                  alt="Preview"
                  style={{ maxWidth: '100%', maxHeight: 250, objectFit: 'contain', borderRadius: 8, border: '1px solid #e0e0e0' }}
                />
              </Box>
            )}
            
            {!metodoPagoSeleccionado?.imagen && !archivoMetodoPago && (
              <Box sx={{ 
                width: '100%', 
                height: 150, 
                backgroundColor: '#f5f5f5', 
                borderRadius: 2, 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center',
                border: '2px dashed #adb5bd'
              }}>
                <Typography variant="body2" color="text.secondary">
                  Sube un QR o imagen representativa de {getMetodoPagoNombre(metodoPagoSeleccionado?.metodo)}
                </Typography>
              </Box>
            )}
            
            <input
              type="file"
              accept="image/jpeg,image/png,image/webp,image/jpg,image/gif"
              ref={fileInputMetodoPagoRef}
              style={{ display: 'none' }}
              onChange={handleSeleccionarImagenMetodoPago}
            />
            
            <Button
              variant="outlined"
              color="primary"
              startIcon={<AddPhotoIcon />}
              onClick={() => fileInputMetodoPagoRef.current?.click()}
              fullWidth
            >
              {archivoMetodoPago ? 'Cambiar archivo' : 'Seleccionar imagen'}
            </Button>
            
            {archivoMetodoPago && (
              <Typography variant="caption" color="text.secondary">
                {archivoMetodoPago.name} ({(archivoMetodoPago.size / 1024).toFixed(1)} KB)
              </Typography>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseMetodoPagoImagenDialog} color="inherit">Cancelar</Button>
          
          {metodoPagoSeleccionado?.imagen && (
            <Button 
              onClick={handleEliminarImagenMetodoPago} 
              color="error" 
              variant="outlined"
              startIcon={<DeletePhotoIcon />}
            >
              Eliminar Imagen
            </Button>
          )}
          
          <Button 
            onClick={handleSubirImagenMetodoPago} 
            variant="contained" 
            color="primary"
            disabled={!archivoMetodoPago}
            startIcon={<AddPhotoIcon />}
          >
            {metodoPagoSeleccionado?.imagen ? 'Actualizar' : 'Subir'}
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity} onClose={() => setSnackbar({ ...snackbar, open: false })}>{snackbar.message}</Alert>
      </Snackbar>
    </Box>
  );
}

export default Ventas;